const ResponsiveDirectusImage = ({ assetLandscape, assetPortrait, alt, pictureClass, imgClass }) => {
  return (
    <picture class={pictureClass}>
      <source
        media="(max-width: 767px)"
        srcSet={`${import.meta.env.VITE_DIRECTUS_API_URL}/assets/${assetPortrait.id} 767w`}
        sizes="767px"
      />
      <source
        media="(min-width: 768px)"
        srcSet={`${import.meta.env.VITE_DIRECTUS_API_URL}/assets/${assetLandscape.id} 1024w`}
        sizes="1024px"
      />
      <img class={imgClass} src={`${import.meta.env.VITE_DIRECTUS_API_URL}/assets/${assetLandscape.id}`} alt={alt} />
    </picture>
  )
};

export default ResponsiveDirectusImage;
